import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'

import App from "./App";
import { AuthContextProvider } from "store/AuthContext";
import { ToastContextProvider } from "store/ToastContext";
import { ModalContextProvider } from "store/ModalContext";

import "./App.css";
import "./style/custom.css";
import "./style/global-style.css"
import "./style/app-adjustment-style.css"
 import axios from 'axios';
 
  axios.interceptors.response.use(
   (res) => {  
//      if (res.status === 201) {
//         console.log('Posted Successfully');
//      }
      return res;
   },
   (err) => {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger      
     if (err.message==='Request failed with status code 401'){
       //console.log("err.message: "+err.message);
         sessionStorage.removeItem('SessionId');   
         window.location.href = '/ExpiredSession'
//         // redirect to the login page  
//         //window.location.href = '/';
     }
//     // return Promise.reject(err);
   }
 );

ReactDOM.render(
  <BrowserRouter>
    <AuthContextProvider>
      <ToastContextProvider>
        <ModalContextProvider>
          <App />
        </ModalContextProvider>
      </ToastContextProvider>
    </AuthContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
